export default (state = true, { type, payload }) => {
    switch (type) {
    case 'MAKE_PRODUCTION_TRUE':
      return true
    case 'MAKE_PRODUCTION_FALSE':
      return false
    default:
      return state
    }
  }
  